module.exports = "https://staticsandbox.coteibem.com.br/assets/category-star-hourglass.9b6ec32df0e8a420f56b9191d412ac28.svg";